import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-request-error',
  templateUrl: './request-error.component.html',
  styleUrls: ['./request-error.component.scss'],
})
export class RequestErrorComponent implements OnInit {
  readonly errors: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public readonly dialogRef: MatDialogRef<RequestErrorComponent>
  ) {}

  ngOnInit(): void {
    if (this.data.length > 0) {
      this.errors.push(this.data);
    } else {
      Object.keys(this.data).forEach((key) => this.errors.push(this.data[key]));
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
